@if (isSuperAdmin()) {
<section class="statistics-page">
    <header class="page-heading">
        <div><div class="eyebrow"><i class="bi bi-people" aria-hidden="true"></i> ANALYTICS</div>
            <h1>User Statistics</h1><p>Explore the Pure Originals and Masters each user worked on.</p></div>
        <div class="heading-actions">
            <button #rangeButton type="button" class="secondary-button range-button" (click)="editRange()" aria-haspopup="dialog" [attr.aria-expanded]="editingRange" aria-controls="user-statistics-range"><i class="bi bi-calendar3" aria-hidden="true"></i>
                <span>{{ formatDate(range.startDate) }} – {{ formatDate(range.endDate) }}</span></button>
            <button type="button" class="icon-button" (click)="load()" [disabled]="loading || !!rangeError" aria-label="Refresh user statistics"><i class="bi bi-arrow-clockwise" aria-hidden="true"></i></button>
        </div>
    </header>
    @if (rangeError) { <p class="error-banner" role="alert">{{ rangeError }} <button type="button" class="text-button" (click)="editRange()">Change dates</button></p> }
    <section class="table-card">
        <div class="table-heading"><div><h2>Activity by user</h2><p>Select a file count to see the user's work in this period.</p></div></div>
        <div class="table-scroll overview-scroll" [attr.aria-busy]="loading">
            <table class="overview-table">
                <thead><tr><th scope="col">User</th><th scope="col" class="numeric">Pure Originals</th><th scope="col" class="numeric">Masters</th><th scope="col">Activity</th><th scope="col">Last activity</th></tr></thead>
                <tbody>
                    @if (loading) { <tr><td colspan="5" class="state" role="status"><span class="spinner" aria-hidden="true"></span>Loading user statistics…</td></tr> }
                    @else if (error) { <tr><td colspan="5" class="state"><p role="alert">{{ error }}</p><button type="button" class="secondary-button" (click)="load()">Try again</button></td></tr> }
                    @else {
                        @for (user of users; track $index) {
                            <tr>
                                <td><strong>{{ user.firstName }} {{ user.lastName }}</strong></td>
                                <td class="numeric"><button type="button" class="count-button" [disabled]="!user.pureOriginalCount || !user.userId"
                                    [attr.aria-label]="'View Pure Originals for ' + user.firstName + ' ' + user.lastName"
                                    (click)="openFiles(user, 'pure-original-stats')">{{ user.pureOriginalCount | number }}<i class="bi bi-arrow-up-right" aria-hidden="true"></i></button></td>
                                <td class="numeric"><button type="button" class="count-button" [disabled]="!user.masterCount || !user.userId"
                                    [attr.aria-label]="'View Masters for ' + user.firstName + ' ' + user.lastName"
                                    (click)="openFiles(user, 'master-stats')">{{ user.masterCount | number }}<i class="bi bi-arrow-up-right" aria-hidden="true"></i></button></td>
                                <td class="muted">{{ user.activityMessage || 'No file work recorded' }}</td>
                                <td class="date-cell">{{ formatDate(user.lastActivityTime) }}</td>
                            </tr>
                        } @empty { <tr><td colspan="5" class="state">No users found for this period.</td></tr> }
                    }
                </tbody>
            </table>
        </div>
    </section>
    <dialog #rangeDialog id="user-statistics-range" class="range-dialog" aria-labelledby="range-dialog-title" (close)="onRangeClosed()" (click)="onRangeBackdropClick($event)">
        <div class="range-dialog-heading"><h2 id="range-dialog-title">Select period</h2>
            <button type="button" class="icon-button" (click)="closeRange()" aria-label="Close date picker"><i class="bi bi-x-lg" aria-hidden="true"></i></button>
        </div>
        <form class="range-form" (ngSubmit)="applyRange()">
            <label>From<input type="datetime-local" name="startDate" [(ngModel)]="draftStart" required></label>
            <label>To<input type="datetime-local" name="endDate" [(ngModel)]="draftEnd" required></label>
            @if (draftRangeError) { <p class="error-banner" role="alert">{{ draftRangeError }}</p> }
            <div class="range-dialog-actions">
                <button type="button" class="secondary-button" (click)="today()">Today</button>
                <span></span>
                <button type="button" class="text-button" (click)="closeRange()">Cancel</button>
                <button type="submit" class="primary-button">Apply range</button>
            </div>
        </form>
    </dialog>
</section>
} @else { <p class="access-message">User statistics are available to Super Admin users.</p> }




